var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 16.933",
    id: "XlsFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.968,
    transform: "matrix(1.03366 0 0 1.03333 -2.911 3.935)",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.9217235,-3.8085938 A 0.25603411,0.25603411 0 0 0 4.6658641,-3.5527344 V 12.322266 a 0.25603411,0.25603411 0 0 0 0.2558594,0.255859 H 17.093598 a 0.25603411,0.25603411 0 0 0 0.255859,-0.255859 V 1.3886719 a 0.25603411,0.25603411 0 0 0 -0.07227,-0.1796875 l -4.796875,-4.9179688 v -0.00195 a 0.25600851,0.25600851 0 0 0 -0.01953,-0.019531 0.25600851,0.25600851 0 0 0 -0.02149,-0.019531 0.25600851,0.25600851 0 0 0 -0.02344,-0.017578 0.25600851,0.25600851 0 0 0 -0.02344,-0.013672 0.25600851,0.25600851 0 0 0 -0.01367,-0.00586 0.25600851,0.25600851 0 0 0 -0.02539,-0.00977 0.25600851,0.25600851 0 0 0 -0.01367,-0.00391 0.25600851,0.25600851 0 0 0 -0.0059,0 0.25600851,0.25600851 0 0 0 -0.03711,-0.00586 0.25600851,0.25600851 0 0 0 -0.01367,-0.00195 0.25600851,0.25600851 0 0 0 -0.0059,0 h -0.0078 z m 0.2558594,0.5117188 h 6.9902341 l 4.669922,4.7890625 V 12.066406 H 5.1775829 Z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.269531 -3.8085938 A 0.25603411 0.25603411 0 0 0 12.021484 -3.5527344 L 12.021484 1.3886719 A 0.25603411 0.25603411 0 0 0 12.277344 1.6445312 L 17.09375 1.6445312 A 0.25603411 0.25603411 0 0 0 17.277344 1.2089844 L 12.460938 -3.7304688 A 0.25603411 0.25603411 0 0 0 12.269531 -3.8085938 z M 12.533203 -2.921875 L 16.488281 1.1328125 L 12.533203 1.1328125 L 12.533203 -2.921875 z ",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 2,
      InkscapeFontSpecification: "Calibri",
      textAlign: "center"
    },
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    "aria-label": "XLS",
    fontFamily: "Calibri",
    fontSize: 5.292,
    opacity: 0.99,
    textAnchor: "middle",
    className: "colorStroke000000 svgStroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437ef7",
    stroke: "none",
    d: "M7.370408 15.004253q.03359.05684.038757.09043.00775.03359-.015503.05426-.023254.01809-.077515.02325-.051676.0078-.1395264.0078-.082682 0-.1291912-.0052-.046509-.0026-.074931-.01292-.025838-.01033-.041341-.02326-.012919-.0155-.023254-.03876L6.1637626 13.769185 5.4118701 15.099854q-.012919.02325-.028422.03876-.015503.0155-.043925.02584-.025838.0078-.072347.01033-.046509.0052-.1240236.0052-.085266 0-.1343588-.0078-.049093-.0052-.069763-.02325-.018087-.02067-.012919-.05426.00775-.03359.041341-.09043L5.879542 13.466878 5.0087936 11.98118q-.031006-.05685-.041341-.09043-.00775-.03617.012919-.05426.020671-.02067.072347-.02584.051676-.0052.1421103-.0052.077515 0 .1266073.0052.049093.0026.077515.01292.028422.0078.041341.02584.012919.0155.028422.03617l.7183028 1.250571.7131352-1.250571q.012919-.02067.025838-.03617.012919-.01809.036174-.02584.025838-.01033.069763-.01292.043925-.0052.1188558-.0052.080099 0 .1291912.0078.051677.0052.072347.02325.023254.01809.018087.05426-.00517.03359-.036174.09043l-.8681646 1.475363zM9.724271 14.970663q0 .05168-.00517.08785-.00517.03359-.018087.05943-.010335.02325-.028422.03617-.015503.01034-.038757.01034H8.1558904q-.059428 0-.1136883-.03876-.051676-.04134-.051676-.14211v-3.09542q0-.02067.010335-.03617.010335-.0155.036174-.02325.025838-.01034.069763-.0155.043925-.0078.1059368-.0078.064595 0 .1059367.0078.043925.0052.069763.0155.025838.0078.036174.02325.010335.0155.010335.03617v2.891298h1.1988939q.023254 0 .038757.01292.018087.01033.028422.03359.012919.02067.018087.05684.00517.03617.00517.08785zM12.008371 14.226522q0 .235128-.08785.418579-.08527.183452-.240296.312643-.152445.126607-.361735.191203-.206706.0646-.447002.0646-.167948 0-.312642-.02842-.14211-.02842-.255799-.06976-.111104-.04134-.188619-.08527-.07493-.04392-.105936-.07493-.028423-.03101-.043926-.07752-.012919-.04909-.012919-.129191 0-.05684.00517-.09302.00517-.03876.015503-.06201.010335-.02326.025838-.03101.015503-.01033.036174-.01033.03617 0 .100769.04392.06718.04392.170532.0956.103353.05168.248047.09818.147278.04392.338481.04392.144694 0 .26355-.03876.12144-.03876.206706-.108521.08785-.07235.134359-.1757.04651-.103352.04651-.235127 0-.142111-.06459-.24288-.0646-.100769-.170532-.1757-.105937-.07752-.24288-.139526-.134359-.0646-.276469-.129191-.14211-.06718-.276469-.147278-.134359-.0801-.240296-.188619-.105936-.108521-.173116-.253215-.06459-.147278-.06459-.3514 0-.20929.07493-.372071.07751-.165364.211873-.276469.136943-.111104.322978-.167948.188619-.05943.40566-.05943.111105 0 .222209.02067.113688.01809.211874.05168.100769.03101.178283.07235.07752.03876.100769.0646.02584.02325.03359.03876.0078.01292.01292.03617.0052.02067.0078.05168.0026.03101.0026.0801 0 .04651-.0052.08268-.0026.03617-.01033.06201-.0078.02325-.02326.03617-.01292.01033-.03101.01033-.02842 0-.09043-.03617-.05943-.03617-.147278-.0801-.08785-.04651-.20929-.08268-.118856-.03876-.268718-.03876-.139526 0-.242879.03876-.103353.03617-.170532.09818-.06718.06201-.10077.147278-.03359.08527-.03359.180868 0 .139526.0646.240295.0646.100769.170533.178284.10852.07752.245463.14211.136943.0646.279053.131775.14211.0646.279053.144694.136942.07752.242879.186036.108521.105936.173116.253214.06718.144694.06718.343649z",
    fontWeight: 400,
    className: "color000000 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.5e8f496e49e2b649c6d7cd281c375bde.svg";
export { ForwardRef as ReactComponent };